<div class="container-fluid">
    <div id="message">
        <iui-messages #messages class="ms-auto me-auto"></iui-messages>
    </div>
    <div *ngIf="!addUserDisplay && !updateUserDisplay">

        <div class="row">
            <button class="col-auto btn btn-primary px-4 mb-2 mt-3" id="addUser" type="button" (click)="displayAddUser()">Add User</button>
        </div>
        <div class="row">
            <div class="col-12">
                <p-table styleClass="p-datatable-striped" [value]="users" [sortOrder]="1" sortField="userName" [columns]="tableColumn" [scrollable]="true" scrollHeight="50vh">
                    <ng-template pTemplate="header" let-columns>
                        <tr *ngIf="users.length > 0">
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="!col.sort">{{col.header}}</th>
                                <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field">
                                    {{col.header}}
                                    <p-sortIcon [field]="col.field"></p-sortIcon>
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td *ngFor="let col of columns" class="noBorder truncate" [ngSwitch]="col.field">
                                <div *ngSwitchCase="'phone'">
                                    {{rowData.phone | phoneNumber }}<span *ngIf="rowData.phoneExtension">&nbsp; Ext. {{rowData.phoneExtension}}</span>
                                </div>
                                <div *ngSwitchCase="'role'">
                                    <div *ngFor="let r of rowData.roleList">{{r | scrConfig:'role'}}</div>
                                </div>
                                <div *ngSwitchCase="'edituser'">
                                    <a href="javascript:void(0)" (click)="userToEdit(rowData)">Edit User</a>
                                    <br *ngIf="!rowData.userName">
                                    <a *ngIf="!rowData.userName" href="javascript:void(0)" (click)="deletePendingUser(rowData)">Delete User</a>
                                </div>
                                <div *ngSwitchCase="'toggleStatus'">
                                    <p-checkbox *ngIf="rowData.userName" [ngModel]="!rowData.disabled" [disabled]="userProfile.userName === rowData.userName" [binary]="true"
                                        (click)="editStatusUser(rowData)" [readonly]="true"></p-checkbox>
                                </div>
                                <div *ngSwitchCase="'send'" style="white-space: normal;">
                                    <a *ngIf="!rowData.userName" href="javascript:void(0)" (click)="resendEmail(rowData)">
                                        Resend Email Invitation
                                    </a>
                                </div>
                                <div *ngSwitchDefault class="truncate" [pTooltip]="rowData[col.field] ? rowData[col.field]: ''" tooltipPosition="top" appShowToolTipIfTruncated>
                                    {{rowData[col.field]}}</div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length" class="noBorder">
                                <b>There are no users.</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <span *ngIf="showMessage()">Please note that any user whose status is currently listed as Disabled is
                    not receiving
                    any email messages generated by the Short Code Registry. <br> This includes messages about short
                    code expirations, renewals,
                    order updates, and notifications.
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="addUserDisplay" class="container-fluid">
        <app-user (emitAction)="receiveChildEvent($event)" [mode]="mode" [user]="userToEditObj"></app-user>
    </div>

    <p-confirmDialog key='selfDisable' #selfDisableDialog [style]="{width: '40vw'}" [closable]="false">
        <p-footer>
            <button i18n id="selfaccept" class="btn btn-primary me-2" type="button" (click)="selfDisableDialog.accept()">OK</button>
        </p-footer>
    </p-confirmDialog>

    <p-confirmDialog key='confirmDisable' #disableDialog [style]="{width: '50vw'}" [closable]="false">
        <p-footer>
            <div class="d-flex justify-content-end">
                <button i18n id="scaccept" class="btn btn-primary me-2" type="button" (click)="disableDialog.accept()">OK</button>
                <button i18n id="screject" class="btn btn-secondary" type="button" (click)="disableDialog.reject()">Cancel</button>
            </div>
        </p-footer>
    </p-confirmDialog>
</div>